import Vue from 'vue'
import Router from 'vue-router'
// 注册router组件
Vue.use(Router)
// 导入组件
import message from '../components/message/message.vue'
import friends from '../components/friends/friends.vue'
import discover from '../components/discover/discover.vue'
import mapwebview from '../components/mapwebview/mapwebview.vue'
import charingmap from '../components/charingmap/charingmap.vue'
import charingmap1 from '../components/charingmap/charingmap1.vue'
import xiexinmapwebview from '../components/xiexinmapwebview/mapwebview.vue'
import mapwebviewPowertransport from '../components/xiexinmapwebview/mapwebviewPowertransport.vue'
import changeContract from '../components/contractDetail/changeContract.vue'
import xiexinwebviewsearchMap from '../components/xiexinmapwebview/searchMap.vue'
import faceFail from '../components/faceFail/faceFail.vue'
import faceSuccess from '../components/faceSuccess/faceSuccess.vue'


let routes = [
  { path: '/faceFail', name: 'faceFail', component: faceFail },
  { path: '/faceSuccess', name: 'faceSuccess', component: faceSuccess },
  { path: '/message', name: 'message', component: message },
  { path: '/friends', name: 'friends', component: friends },
  { path: '/mapwebview', name: 'mapwebview', component: mapwebview },
  { path: '/charingmap', name: 'charingmap', component: charingmap },
  { path: '/charingmap1', name: 'charingmap1', component: charingmap1 },
  { path: '/changeContract', name: 'changeContract', component: changeContract },
  { path: '/xiexinmapwebview', name: 'xiexinmapwebview', component: xiexinmapwebview },
  { path: '/mapwebviewPowertransport', name: 'mapwebviewPowertransport', component: mapwebviewPowertransport },
  { path: '/xiexinwebviewsearchMap', name: 'xiexinwebviewsearchMap', component: xiexinwebviewsearchMap },
  { path: '/discover', name: 'discover', component: discover },
  { path: '/', name: 'changeContract', component: changeContract },
]

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js